import type { JSX } from 'preact';

function NavIcon({ kind }: { kind: string }): JSX.Element {
  const paths: Record<string, string> = { box: 'M3 6h18v14H3z M3 11h18 M9 6v14 M15 6v14 M7 3h10', log: 'M5 3h14v18H5z M8 7h8 M8 11h8 M8 15h5', flock: 'M12 3v18 M12 11C5 11 3 7 3 4c6 0 9 3 9 7Z M12 17c7 0 9-4 9-7-6 0-9 3-9 7Z', account: 'M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0 M4 21v-2a8 8 0 0 1 16 0v2' };
  return <svg class="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d={paths[kind]} /></svg>;
}

export function MemberHeader(): JSX.Element {
  return <header class="topbar">
    <a class="brand" href="/box"><img class="ff-badge" src="/brand/badge-96.webp" srcset="/brand/badge-96.webp 96w, /brand/badge-192.webp 192w" sizes="3.5rem" width="96" height="96" alt="" /><span>Flock &amp; Furrow<small>The member journal</small></span></a>
    <a class="farm-link" href="https://flockandfurrow.farm">Farm site <span aria-hidden="true">↗</span></a>
  </header>;
}

export function MemberNav({ location, signedIn }: { location: string; signedIn: boolean }): JSX.Element {
  const links = [
    { href: '/box', label: 'Box journal', icon: 'box' },
    { href: '/log', label: 'Farm log', icon: 'log' },
    { href: '/flock', label: 'The flock', icon: 'flock' },
    { href: '/account', label: 'My account', icon: 'account' },
  ];
  return <nav class="member-nav" aria-label="Member area">{links.map(link => {
    const active = location === link.href || location.startsWith(`${link.href}/`) || (link.href === '/account' && location === '/login');
    const href = signedIn || link.href === '/box' ? link.href : `/login?next=${encodeURIComponent(link.href)}`;
    return <a key={link.href} href={href} aria-current={active ? 'page' : undefined}><NavIcon kind={link.icon} />{link.label}</a>;
  })}</nav>;
}

export function MemberFooter(): JSX.Element {
  return <footer class="member-footer"><span>Flock &amp; Furrow Farm</span><a href="https://flockandfurrow.farm">Back to the farm site ↗</a></footer>;
}
